import React, { useMemo } from "react";
import Chart from "react-apexcharts";

export const ActivityRevenueSection = ({
  dashboardData,
  isAdminUser,
  todayActivityOptions,
  todayActivitySeries,
  momRevenueOptions,
  momRevenueSeries,
}) => {
  const resolvedMomRevenueOptions = useMemo(
    () => ({
      ...momRevenueOptions,
      chart: {
        ...momRevenueOptions?.chart,
        foreColor: "#1f2937",
      },
      plotOptions: {
        ...momRevenueOptions?.plotOptions,
        bar: {
          ...momRevenueOptions?.plotOptions?.bar,
          dataLabels: {
            ...momRevenueOptions?.plotOptions?.bar?.dataLabels,
            position: "center",
          },
        },
      },
      dataLabels: {
        ...momRevenueOptions?.dataLabels,
        textAnchor: "middle",
        style: {
          ...momRevenueOptions?.dataLabels?.style,
          colors: ["#ffffff"],
          fontWeight: 800,
        },
        dropShadow: {
          enabled: true,
          top: 1,
          left: 1,
          blur: 2,
          opacity: 0.45,
        },
      },
      xaxis: {
        ...momRevenueOptions?.xaxis,
        labels: {
          ...momRevenueOptions?.xaxis?.labels,
          style: {
            ...momRevenueOptions?.xaxis?.labels?.style,
            colors: "#374151",
            fontWeight: 600,
          },
        },
      },
      yaxis: {
        ...momRevenueOptions?.yaxis,
        labels: {
          ...momRevenueOptions?.yaxis?.labels,
          style: {
            ...momRevenueOptions?.yaxis?.labels?.style,
            colors: "#111827",
            fontWeight: 700,
          },
        },
      },
      tooltip: {
        ...momRevenueOptions?.tooltip,
        theme: "light",
      },
    }),
    [momRevenueOptions],
  );

  return (
    <div className="row g-3 mb-3">
      {isAdminUser && (
        <div className="col-12 col-lg-12">
          <div className="card h-100">
            <div className="card-header">
              <h6 className="card-title mb-0">Revenue (Last vs Current)</h6>
            </div>
            <div className="card-body">
              <style>
                {`
                  .activity-revenue-chart .apexcharts-datalabel,
                  .activity-revenue-chart .apexcharts-data-labels text {
                    fill: #ffffff !important;
                    color: #ffffff !important;
                    font-size: 13px !important;
                    font-weight: 800 !important;
                    opacity: 1 !important;
                    filter: drop-shadow(0 1px 1px rgba(17, 24, 39, 0.85));
                  }
                `}
              </style>
              <div className="activity-revenue-chart">
                <Chart
                  options={resolvedMomRevenueOptions}
                  series={momRevenueSeries}
                  type="bar"
                  height={280}
                  width="100%"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
